

import React, { useEffect, useState } from "react";
import {
  FaUserEdit,
  FaFileAlt,
  FaQuestionCircle,
  FaSignOutAlt
} from "react-icons/fa";
import Header from "../Header";
import Footer from "../../LandingPage/Footer";
import { useNavigate } from "react-router-dom";
import NavBar from "./PropertyOwnerNavbar";

const PropertyOwnerProfile = () => {
  const [profile, setProfile] = useState(null);


  const navigate = useNavigate();

const handleLogout = () => {
  // Clear storage
  localStorage.clear();
  sessionStorage.clear();

  // Navigate to landing page
  navigate("/mainlandingpage", { replace: true });
};


  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (!storedUser) return;

    fetch("https://api.propertygalleria.in/master/api/get/users")
      .then(res => res.json())
      .then(data => {
        const matchedUser = data.find(
          u => u.id === storedUser.id && u.role === storedUser.role
        );
        setProfile(matchedUser);
      });
  }, []);

  if (!profile) return <p style={{ padding: 40 }}>Loading...</p>;

  return (
    <>
     <NavBar/>
    <div style={page}>
      <div style={container}>

        {/* LEFT PROFILE CARD */}
        <div style={leftCard}>
          <div style={avatar}>
            {profile.name?.charAt(0).toUpperCase()}
          </div>

          <h2>{profile.full_name}</h2>
          <span style={role}>{profile.role}</span>

          <div style={info}>
            <p>📧 {profile.email}</p>
            <p>📞 {profile.mobile_number}</p>
          </div>
        </div>

        {/* RIGHT ACTIONS */}
        <div style={rightCard}>
          <Action icon={<FaUserEdit />} label="Edit Profile" />
          <Action icon={<FaFileAlt />} label="My Documents" />
          <Action icon={<FaQuestionCircle />} label="Help & Support" />

          <button style={logoutBtn} onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </button>
        </div>

      </div>
    </div>

     <Footer/>
    </>
  );
};

const Action = ({ icon, label }) => (
  <div style={actionRow}>
    <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
      {icon}
      <span>{label}</span>
    </div>
    <span>›</span>
  </div>
);

export default PropertyOwnerProfile;

const page = {
  minHeight: "100vh",
  background: "#f4f6fb",
  padding: 40,
  paddingTop: '100px',
};

const container = {
  maxWidth: 1100,
  margin: "0 auto",
  display: "grid",
  gridTemplateColumns: "1fr 2fr",
  gap: 30
};

const leftCard = {
  background: "#fff",
  borderRadius: 16,
  padding: 30,
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  textAlign: "center"
};

const avatar = {
  width: 120,
  height: 120,
  borderRadius: "50%",
  background: "#8b2f6c",
  color: "#fff",
  fontSize: 48,
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 15px"
};

const role = {
  color: "#2f9e7a",
  fontWeight: 600
};

const info = {
  marginTop: 20,
  color: "#555"
};

const rightCard = {
  background: "#fff",
  borderRadius: 16,
  padding: 30,
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
};

const actionRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "18px 0",
  borderBottom: "1px solid #eee",
  cursor: "pointer",
  fontSize: 16
};

const logoutBtn = {
  marginTop: 30,
  width: "100%",
  background: "#8b2f6c",
  color: "#fff",
  border: "none",
  padding: 14,
  borderRadius: 12,
  fontSize: 16,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 10
};

